// extracted by mini-css-extract-plugin
module.exports = {"statistics-container-vicri":"CitiesViCRIBlock_statistics-container-vicri__1oEn8"};